import moment from 'moment'
import numeral from 'numeral'

export const MedicalRecord = {
  id: '',
  patientId: '',
  patientName: '',
}

export const MedicalRecordDetail = {
  id: '',
  role: 'doctor',
  medicalRecordId: '',
  date: moment().format('YYYY-MM-DD'),
  teeth: '',
  description: '',
  treatmentType: '',
  percent: 0,
  totalAfterPercent: 0,
  isPayable: false,
  handledBy : '',
  handledByName: '',
  treatmentId: '',
  treatmentName: '',
  suppliesId: '',
  suppliesName: '',
  discount: 0,
  subtotal: 0,
}